import React from "react";
import Main from "../../components/layout/Main";
import { Form, Input, Button, Row, Col } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

function ContactPage() {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    console.log("Contact Form Submitted:", values);
    form.resetFields();
  };

  return (
    <Main>
      <section>
        <div className="contact-main-div">
          {/* Heading */}
          <div className="contact-heading-div">
            <h1>Contact Us</h1>
            <p>
              Have questions or need help? Reach out to our support team
              anytime.
            </p>
          </div>

          {/* Contact Info */}
          <Row gutter={[20 , 20]} className="contact-info-row">
            <Col xs={24} md={8}>
              <div className="contact-card">
                <MailOutlined className="contact-icon" />
                <h3>Email Us</h3>
                <p>support@gamehub.com</p>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="contact-card">
                <PhoneOutlined className="contact-icon" />
                <h3>Call Us</h3>
                <p>+1 (800) 123-4567</p>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className="contact-card">
                <EnvironmentOutlined className="contact-icon" />
                <h3>Visit Us</h3>
                <p>123 Gaming Street, eSports City</p>
              </div>
            </Col>
          </Row>

          {/* Contact Form */}
          <div className="contact-form-div">
            <h2>Send Us a Message</h2>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              className="contact-form"
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    validator: (_, values) => {
                      if (!values || !values.trim()) {
                        return Promise.reject(
                          new Error("Please enter your name")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <Form.Item
                label="Message"
                name="message"
                rules={[
                  {
                    required: true,
                    validator: (_, values) => {
                      if (!values || !values.trim()) {
                        return Promise.reject(
                          new Error("Message are required")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input.TextArea
                  rows={5}
                  placeholder="Write your message here..."
                />
              </Form.Item>

              <Form.Item>
                <Button htmlType="submit" className="Fill-button">
                  Send Message
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </section>
    </Main>
  );
}

export default ContactPage;
